{
  "validation": {
    "required": "This information is required",
    "invalidDate": "Invalid date. Please use the format DD.MM.YYYY.",
    "tooSmallDate": "The date is too early",
    "moveDateAfterEndDate": "The move-out date cannot be after the final date of the agreement.",
    "tooBigDate": "The date is too late",
    "invalidPostalCode": "Invalid postcode",
    "invalidNumber": "Invalid number",
    "tooBig": "Value too high",
    "tooSmall": "Value too low",
    "invalidIban": "Invalid account number",
    "invalidBic": "Invalid BIC",
    "invalidType": "Invalid value",
    "invalidEmail": "Invalid email address",
    "invalidPhoneNumber": "Invalid phone number",
    "invalidString": "Invalid value",
    "invalidSsn": "Invalid social security number",
    "invalidPin": "Invalid code",
    "invalidReturnPercentageSum": "The return percentages must add up to 100 %.",
    "invalidRooReturnPercentageSum": "The right-of-occupancy fee return portions must add up to 100 % or all be empty.",
    "titleDescriptionOrFilesRequired": "A subject, description or attachment is mandatory",
    "noResidentUser": "The resident does not have a resident portal account. The account must first be created by registering on the resident portal.",
    "terminatedAdultMissingResidentUser": "The selected adult to be terminated does not have resident portal credentials. This person cannot be terminated through the resident portal.",
    "noAdultLeft": "There will be no adult left in the apartment to whom the agreement could be transferred.",
    "otherContractPartyTermination": "You can only terminate the other contract party when terminating the entire agreement.",
    "too_small_date": "The date is too early",
    "invalid_date": "Invalid date",
    "too_big_date": "The date is too late",
    "move_date_after_end_date": "The move-out date cannot be after the final date of the agreement.",
    "invalid_postal_code": "Invalid postcode",
    "invalid_number": "Invalid number",
    "invalid_iban": "Invalid account number",
    "invalid_bic": "Invalid BIC",
    "invalid_email": "Invalid email address",
    "invalid_phone_number": "Invalid phone number",
    "invalid_string": "Invalid value",
    "invalid_ssn": "Invalid social security number",
    "invalid_pin": "Invalid code",
    "invalid_return_percentage_sum": "The return percentages must add up to 100%",
    "invalid_roo_return_percentage_sum": "The right-of-occupancy fee return portions must add up to 100 % or all be empty.",
    "title_description_or_files_required": "A subject, description or attachment is mandatory",
    "no_resident_user": "The resident does not have a resident portal account. The account must first be created by registering on the resident portal.",
    "terminated_adult_missing_resident_user": "The selected adult to be terminated does not have resident portal credentials. This person cannot be terminated through the resident portal.",
    "no_adult_left": "There will be no adult left in the apartment to whom the agreement could be transferred.",
    "other_contract_party_termination": "You can only terminate the other contract party when terminating the entire agreement."
  },
  "other": {
    "noActiveContracts": "You currently do not have a valid agreement.",
    "errorFecthingContracts": "Error when searching for agreements. Please try logging in again.",
    "internalError": "Something went wrong.",
    "internalErrorLogin": "Please try logging in again.",
    "genericError": "Oops, something went wrong. Please try again later.",
    "pageLoadTimedOut": "An error occurred while loading the page. Please try again in a moment.",
    "pageOutOfOrder": "The resident pages are not in use at the moment. Please try again later.",
    "staleClientRefreshRequired": "The page has been updated. Please reload the page and try the termination again.",
    "identificationRequired": "Confirming the operation requires strong authentication. Authenticate on the My information page and try again.",
    "pageNotFound": "The page you were looking for could not be found",
    "defectNoticeSubmitError": "An error occurred while sending your fault report. If the problem persists or if the fault is urgent, please contact customer service.",
    "defectNoticeAPIError": "Fault reports cannot be created at the moment. Please try again later.",
    "additionalNotification": "For urgent matters, please contact customer services.",
    "backToLogin": "To the login page",
    "registrationIsOutOfOrder": "Registration is not possible right now. Please try again later.",
    "noPhoneNumber": "The fault report function is not available",
    "noPhoneNumberText": "To continue reporting a fault, please add your phone number to your profile.",
    "failedToOpenAttachment": "Failed to open attachment",
    "errorLoadingBuilding": "Error loading building information. Please try again later.",
    "incorrectRegistrationProvider": "Registration failed. Please try again.",
    "unboundResidentUser": "Error fetching agreements. Please contact our customer service.",
    "eventId": "Error code: {{id}}"
  },
  "auth": {
    "errorUserNotVerified": "The user's email address has not been verified.",
    "invalidCredentials": "Incorrect username or password"
  }
}
